// extracted by mini-css-extract-plugin
var _1 = "AILengthDropdownItemContent-moduleavatar__B4Ex9 SelectEntityItemAvatar-moduleavatar__zeGPU";
var _2 = "AILengthDropdownItemContent-moduleavatarActive__YSedP";
export { _1 as "avatar", _2 as "avatarActive" }
